import tw, { styled } from 'twin.macro';

const TextPanel = styled.div`
  ${tw`text-sm mb-6 bg-gray-300 p-4`};
`;

export default TextPanel;
